import { render, staticRenderFns } from "./CurrentTeachers.vue?vue&type=template&id=6ac3303f&"
import script from "./CurrentTeachers.vue?vue&type=script&lang=js&"
export * from "./CurrentTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports